<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Tutoriais</h2>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
  			<app-detalhe-documento-list [isProjeto]="false" [idDoc]="1"></app-detalhe-documento-list>
        </div>
      </div>
    </div>
  </div>
</div>
